import React, { useState } from 'react';
import { apiService } from '../../../../services/api';
import { CreateOrigemData } from '../../../../types/origens';
import { toast } from 'react-toastify';
import './QuickOriginForm.css';

interface QuickOriginFormProps {
  onSuccess: (newOrigin: any) => void;
  onCancel: () => void;
}

const QuickOriginForm: React.FC<QuickOriginFormProps> = ({
  onSuccess,
  onCancel
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [newOrigem, setNewOrigem] = useState<CreateOrigemData>({
    nome: '',
    descricao: ''
  });

  const handleSubmit = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    // Validação ANTES de setar loading
    if (!newOrigem.nome.trim()) {
      toast.error('O nome da origem é obrigatório');
      return;
    }

    try {
      setIsSubmitting(true);

      const response = await apiService.createOrigem(newOrigem);

      if (response && response.data) {
        // Limpar form antes de chamar onSuccess
        setNewOrigem({ nome: '', descricao: '' });

        // Chamar callback de sucesso (o toast será mostrado no parent)
        onSuccess(response.data);
      }
    } catch (error) {
      console.error('Erro ao criar origem:', error);
      toast.error('Erro ao criar origem');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="quick-origin-form-wrapper">
      <div className="alert alert-info d-flex align-items-center mb-3">
        <i className="ti ti-info-circle me-2"></i>
        <span>Cadastro rápido - Adicione uma nova origem</span>
      </div>

      <div className="row">
        {/* Nome da Origem */}
        <div className="col-12 mb-3">
          <label className="form-label">
            Nome da Origem <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            value={newOrigem.nome}
            onChange={(e) => setNewOrigem(prev => ({ ...prev, nome: e.target.value }))}
            placeholder="Ex: Indicação, Portal X, Facebook"
            autoFocus
          />
        </div>

        {/* Descrição */}
        <div className="col-12 mb-3">
          <label className="form-label">Descrição</label>
          <textarea
            className="form-control"
            rows={3}
            value={newOrigem.descricao}
            onChange={(e) => setNewOrigem(prev => ({ ...prev, descricao: e.target.value }))}
            placeholder="Detalhes opcionais sobre esta origem..."
          />
        </div>

        {/* Botões de Ação */}
        <div className="col-12">
          <div className="d-flex gap-2 justify-content-end pt-2 border-top">
            <button
              type="button"
              className="btn btn-light"
              onClick={onCancel}
              disabled={isSubmitting}
            >
              <i className="ti ti-x me-1"></i>
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Salvando...
                </>
              ) : (
                <>
                  <i className="ti ti-check me-1"></i>
                  Salvar Origem
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickOriginForm;
